export default __webpack_public_path__ + "static/210512_更新完成_en-35570444224b5f466753c6db9893b2ce.png";